import { Spinner } from "@/components/ui/spinner.tsx";
import { cn } from "@/lib/utils";
import { FunctionComponent, HTMLAttributes } from "react";

export type LoadingProps = HTMLAttributes<HTMLDivElement> & {};

export const Loading: FunctionComponent<LoadingProps> = (props) => {
	const { className, ...otherProps } = props;
	return (
		<div
			{...otherProps}
			className={cn("flex flex-1 items-center justify-center", className)}
		>
			<Spinner />
		</div>
	);
};
